/* 🤖 this file was generated by svg-to-ts */
export const iconFrontierwallet: {
  name: 'frontierwallet';
  data: string;
} = {
  name: 'frontierwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#BF7547" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" fill-rule="evenodd" d="m24.04 6.88-.11.28-.38.88-.25.57c-1.89 4.25-3.36 6.27-4.93 6.27-.9 0-1.44-.24-2.13-.79l-.2-.16c-.5-.42-.71-.52-1.18-.52-.25 0-.7.29-1.26.97-.59.7-1.23 1.74-1.92 3.1l-.06.13h6.71l-.84 1.57h-6.27v6.46H9.38V6.88zm-2.61 1.58h-10.2v6.25c1.22-1.92 2.38-2.89 3.63-2.89.97 0 1.54.25 2.27.83l.21.17c.46.39.64.48 1.04.48.44 0 1.6-1.67 3.06-4.83z" clip-rule="evenodd"/></svg>`,
};
